import styled from 'styled-components';
import { SEARCH_IFRAME_OFFSET_BOTTOM, SEARCH_IFRAME_OFFSET_TOP } from '../../constants';
export const StyledSearchScrollableWrapper = styled.div.withConfig({
  displayName: "StyledSearchScrollableWrapper",
  componentId: "beren4-0"
})(["--search-icon-fill:", ";display:block !important;", ""], ({
  isOpen,
  theme
}) => isOpen ? theme.color['icon-core-subtle'] : theme.color['border-core-subtle'], ({
  isOpen,
  disableScroll,
  theme
}) => isOpen && `
        width: min-content !important;
        height: min-content !important;
        min-width: calc(515px + ${theme.space['600']} + ${theme.space['600']});
        overflow: ${disableScroll ? 'hidden' : 'auto'};
        position: relative;
        max-width: calc(100vw - var(--global-nav-vertical-nav-width) - var(--copilot-sidebar-width) - 10px);
        max-height: calc(100vh - ${SEARCH_IFRAME_OFFSET_TOP}px - ${SEARCH_IFRAME_OFFSET_BOTTOM}px);
      `);